export const ACCOUNT_IS_LOCKED = "Mail của bạn đã bị khóa. Vui lòng thử lại sau."

export const SEND_MAIL_ERROR_MESSAGE = "Đã xảy ra lỗi. Vui lòng thử lại."

export const NOT_FOUND_MAIL_MESSAGE = "Mail chưa được phân quyền truy cập hệ thống. Bạn vui lòng liên hệ đội ISTORAGE để được hỗ trợ.";

export const OVER_TIME_GET_OTP_MESSAGE = "Bạn đã lấy OTP quá số lần được phép. Vui lòng thử lại sau.";

export const OVER_TIME_SEND_OTP_MESSAGE = "Bạn đã nhập OTP quá số lần được phép. Vui lòng thử lại sau.";

export const OTP_WRONG_MESSAGE = "OTP không hợp lệ. Bạn vui lòng kiểm tra lại.";

export const NOT_FOUND_OTP_MESSAGE = "Không tìm thấy OTP.";